import Button from "../../../custom/button/button";
import { ReactComponent as Edit } from "../../../assets/Edit.svg";
import { ReactComponent as DownloadPdf } from "../../../assets/Export Pdf.svg";
import { ReactComponent as Document } from "../../../assets/Group (5).svg";
import styles from "../dashboardPage.module.scss";
import PageLayout from "../../../layouts/pageLayout/pageLayout";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createUpdateInstitution,
  getInstitutionById,
} from "../../../utils/request";
import { useParams } from "react-router-dom";
import { formatDate } from "../../../utils/formatDate";
import { App, Modal, Spin } from "antd";
import InstitutionForm from "../../../components/onboardingSteps/institution/form";
import { useState } from "react";
import { useAtomValue } from "jotai";
import { userAtom } from "../../../utils/store";

const Institute = () => {
  const { id } = useParams();
  const [openModal, setOpenModal] = useState(false);
  const user = useAtomValue(userAtom);

  const queryClient = useQueryClient();
  const { notification } = App.useApp();

  const { data, isLoading } = useQuery({
    queryKey: ["get-institution-id"],
    queryFn: () => getInstitutionById(Number(id)),
  });

  const institutionData = data?.data ?? ({} as InstitutionData);

  const createUpdateInstitutionMutation = useMutation({
    mutationFn: createUpdateInstitution,
  });

  const institution = [
    {
      institutionName: institutionData?.institutionName,
      discipline: institutionData?.discipline,
      cgpa: institutionData?.cgpa,
      startDate: formatDate(institutionData?.startDate),
      endDate: formatDate(institutionData?.endDate),
      upload: null,
    },
  ];

  const handleCreateUpdateInstitution = async (values: Institution) => {
    const formData = new FormData();

    formData.append("Id", id ?? "");
    formData.append("ApplicantId", user?.applicantId ?? '');
    formData.append("InstitutionName", values.institutionName);
    formData.append("Discipline", values.discipline);
    formData.append("CGPA", values.cgpa);
    formData.append("StartDate", values.startDate);
    formData.append("EndDate", values.endDate);
    if (values.upload) {
      formData.append("Certificate", values.upload);
    }

    try {
      await createUpdateInstitutionMutation.mutateAsync(formData, {
        onSuccess: (data) => {
          notification.success({
            message: "Success",
            description: data?.message,
          });

          queryClient.refetchQueries({ queryKey: ["get-institution-id"] });
          setOpenModal(false);
        },
      });
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error?.response?.data?.message,
      });
    }
  };

  const handleModal = () => {
    setOpenModal((prevState) => !prevState);
  };

  if (isLoading) {
    return <Spin size="large" />;
  }

  return (
    <PageLayout
      heading="Institution"
      headerActions={
        <>
          <Button iconBefore={<Edit />} text="Edit" onClick={handleModal} />
          <Button
            iconBefore={<DownloadPdf />}
            text="Download"
            bgColor="#CE9938"
          />
        </>
      }
    >
      <section className={styles?.section}>
        <p>Institution Attended: {institutionData?.institutionName} </p>
        <p>Discipline: {institutionData?.discipline} </p>
        <p>Year(start date): {formatDate(institutionData?.startDate)} </p>
        <p>Year(End date): {formatDate(institutionData?.endDate)}</p>
        <p>Grade: {institutionData?.cgpa}/5.0</p>
      </section>

      <section className={styles.docTable}>
        <div className={styles.docRow}>
          <div className={styles.docCell}>
            <p className={styles.title}>Certificate </p>
            <Document className={styles.doc} />
            <p className={styles.doc}>{institutionData?.certificateUrl}</p>
            {/* <p className={styles.size}>911kb</p> */}
          </div>
        </div>
      </section>

      <Modal
        open={openModal}
        onCancel={handleModal}
        footer={null}
        width="720px"
      >
        <div className={styles.modalContent}>
          <div>
            <p>Institution</p>
            <p>Input details of your attended institution (if any)</p>
          </div>

          <hr />

          <br />

          <InstitutionForm
            editIndex={0}
            institution={institution}
            certificateUrl={institutionData?.certificateUrl}
            buttonText="Edit"
            onSubmit={handleCreateUpdateInstitution}
            isLoading={createUpdateInstitutionMutation?.isPending}
          />
        </div>
      </Modal>
    </PageLayout>
  );
};

export default Institute;
